import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export interface CreditsResponse {
  credits: number;
  freeCredits: number;
  bonusFreeCredits?: number; // One-time bonus credits (e.g. app download), separate from daily freeCredits
  subscription: string;
  nextFreeCreditsResetTime?: string; // ISO timestamp (UTC) when freeCredits will reset - frontend formats in user's timezone
}

export const getCredits = async (accessAuthToken: string, signal?: AbortSignal): Promise<CreditsResponse> => {
  const maxRetries = 3;
  const retryDelay = 500;

  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/credits`, {
        headers: {
          Authorization: `Bearer ${accessAuthToken}`,
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        // signal: signal,
        credentials: "include",
      });

      if (response.status === 404 && attempt < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        continue;
      }

      if (!response.ok) {
        throw new Error(`Failed to load credits: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      if (attempt === maxRetries - 1) {
        showErrorToast("Error to get user credits");
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
    }
  }
  throw new Error("Could not get user credits");
};
